import axios from 'axios';

// Foodbook Api Options

const api_path = 'https://api.foodbook.vn/ipos/ws/';

const api_key = 'XQ83TOAY44NMQPRY5P6LFIAHUT1ZFXKR';

const _brand = 'PCHM';

const _restaurant_IDs = ['8518','9738','9757','14817','15515','18581','18819','24452'];

const HotLine = '024 3823 8563';

// Google API
const google_api_key = 'AIzaSyAUY-T_NsSduIoG2I5ER_q9FScsd7IAs5A';

// Payments

// Cấu hình VnPay

const vnpay_publish = true;
const vnpay_merchant = 'SUONM001';
const vnpay_hash = 'FECFULMGCINZIMIPCPWFHWTSYYRILYUM';
const vnpay_url = 'https://pay.vnpay.vn/vpcpay.html';

const vnpay_info = {
  publish: true,
  merchant: 'SUONM001',
  hash: 'FECFULMGCINZIMIPCPWFHWTSYYRILYUM',
  redirect_url: 'https://pay.vnpay.vn/vpcpay.html',
}

const vnpay_payment_types = [
  {id: 1, title: 'Thanh toán quét mã VNPAY', component: 'VnPayQR' , name: 'VnPayQR' },
  {id: 2, title: 'Thẻ ATM/Tài khoản Ngân hàng', component: 'VnPayATM' , name: 'VnPayATM' },
  {id: 3, title: 'Thẻ thanh toán quốc tế', component: 'VnPayVISA' , name: 'VnPayVISA' },
  {id: 4, title: 'Ví điện tử', component: 'VnPayWallet' , name: 'VnPayWallet' },
];

const bank_payment_types = [
  {
    id: 1, title: 'Techcombank', component: 'IconTechcomBank', name: 'Techcombank', account: [
      {id: 1, name: 'account_holder', label: 'Chủ tài khoản', value: 'Đào Hữu Thắng'},
      {id: 2, name: 'account_number', label: 'Stk', value: '4384832489324'},
      {id: 3, name: 'content', label: 'Nội dung', value: 'Ten_ttphocuon'},
    ],
  },
  {
    id: 2, title: 'Vietcombank', component: 'IconVietcomBank', name: 'Vietcombank', account: [
      {id: 1, name: 'account_holder', label: 'Chủ tài khoản', value: 'Đào Hữu Thắng'},
      {id: 2, name: 'account_number', label: 'Stk', value: '432432489324'},
      {id: 3, name: 'content', label: 'Nội dung', value: 'Ten_ttphocuon'},
    ],
  },
];

const _payments = [
  {id: 1, title: 'Thanh toán bằng tiền mặt khi nhận hàng' , description: '' , type: "COD"},
  // {id: 2, title: 'Chuyển qua tài khoản ngân hàng' , description: '' , type: "TRANSFER" , children: bank_payment_types},
  // {id: 3, title: 'Ví điện tử MOMO' , description: '' , type: "MomoPay"},
  // {id: 4, title: 'Thanh toán trực tuyến qua Cổng thanh toán VNPAY' , description: '(Chấp nhận thẻ ngân hàng nội địa, thẻ Visa/MasterCard)' , type: "VnPay" , children: vnpay_payment_types , info: vnpay_info },
];



// Shipments
const _shipments = [
  {id: 1, title: "Đặt giao hàng", name: "delivery", description: "Giao hàng tận nơi", icon: "",component: "IconDelivery64"},
  {id: 2, title: "Đặt Pickup", name: "pickup", description: "Nhận hàng tại cơ sở của Hương Mai", icon: "",component: "IconPickup64" },
];

export default {
  // Restaurants
  async getRestaurants (cb) {
    let api_url = wzFoodbookData ? wzFoodbookData.restapi : ''
    let list = await axios.get(api_url + '/pos')
      .then(response => response.data)
    return cb(list)
  },

  // Shipments
  getShipments (cb) {
    return cb(_shipments);
  },

  // Shipments
  getPayments (cb) {
    return cb(_payments);
  },

}



// WEBPACK FOOTER //
// ./src/api/shop.js